import { render, staticRenderFns } from "./NewCollaboratorModal.vue?vue&type=template&id=57f22334&"
import script from "./NewCollaboratorModal.vue?vue&type=script&lang=js&"
export * from "./NewCollaboratorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports